const ModalSearchLawyer = () => {
  return (
    <div id="modal-lawyer-search">
      <div className="loader"></div>
      <p>Su solicitud ha sido enviada</p>
      <p className="search">Buscando abogado</p>
    </div>
  );
};

export default ModalSearchLawyer;
